export enum KeyboardModifierKeyTypes {
  Shift = 'shift',
  Alt = 'alt',
  Option = 'option',
  Control = 'control',
  Command = 'command',
  Meta = 'meta',
}
